'use es6';

import http from 'hub-http/clients/apiClient';
const ENDPOINT = '/eligibility-engine/v2/info/purchase-motions';
export const fetchPurchaseMotions = () => {
  return http.get(ENDPOINT);
};